import { Stack, Group, Text, ActionIcon } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import ClientLookup from "../../../../../common/ClientLookup";

function ClientSection({
  formData,
  onChange,
  onClose,
  errors,
  validateSection,
  disabled,
}) {
  const handleClose = () => {
    validateSection("client");
    onClose();
  };

  return (
    <Stack p="md">
      {/* Header */}
      <Group justify="space-between">
        <Text size="lg" fw={500}>
          Select Client
        </Text>
        <ActionIcon
          onClick={handleClose}
          variant="subtle"
          color="var(--mantine-color-teal-1)"
        >
          <IconCheck size={20} color="var(--mantine-color-teal-6)" />
        </ActionIcon>
      </Group>

      {/* Client Lookup */}
      <ClientLookup
        value={formData.clientUuid}
        onChange={(value) => {
          onChange({ clientUuid: value });
        }}
        error={errors.clientUuid}
        disabled={disabled}
      />
    </Stack>
  );
}

export default ClientSection;
